export default import.meta.ROLLDOWN_FILE_URL_GqVLKv$r8Vnhx8e5bK1vqg